import Vue from 'vue'
import VueRouter from 'vue-router'
import vueHeadful from 'vue-headful';
import VueHead from 'vue-head'
import VueGtm from 'vue-gtm';
import VueGtag from "vue-gtag";
import VModal from 'vue-js-modal'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import NProgress from 'nprogress'
import 'bootstrap'; import 'bootstrap/dist/css/bootstrap.min.css';
import store from './store'
import getRoutes from './routes';
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFacebookF, faAngleDoubleRight, faEllipsisH, faCaretDown, faTimes, faUser, faCalendarDay)

export const Global = Object.keys({
  WIN_INFO: null,
  MARKER: null,
  MAP: null
})

Vue.prototype.$appName = 'mToilet'

Vue.config.productionTip = false;

Vue.component('vue-headful', vueHeadful);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueHead)
Vue.use(VueRouter);
Vue.use(VModal)
Vue.use(VueI18n)

// eslint-disable-next-line no-console
console.log("User allow for Google Analytics: ", store.state.analyticsConsentState)
Vue.use(VueGtag, {
  config: { id: "UA-138061060-1" },
  enabled: store.state.analyticsConsentState
});

let locale;
let storedLocale = store.getters.getLocale
if (storedLocale === null || (storedLocale !== process.env.VUE_APP_LOCALE && storedLocale !== 'en')) {
  locale = process.env.VUE_APP_LOCALE
} else {
  locale = storedLocale
}
document.documentElement.lang = locale;
if (storedLocale !== locale){
  store.dispatch('changeLocale', locale);
}

const i18n = new VueI18n({
  locale: locale
})

const router = new VueRouter({
  mode: 'history',
  routes: getRoutes(locale),
  scrollBehavior() {
    return {x: 0, y: 0}
  }
});

Vue.use(VueGtm, {
  id: 'GTM-N7T7WTN',
  vueRouter: router,
  debug: true,
  trackOnNextTick: false
});
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  NProgress.start();
  return config;
}, function (error) {
  // eslint-disable-next-line no-console
  console.error(error)
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  NProgress.done();
  return response;
}, function (error) {
  // eslint-disable-next-line no-console
  console.error(error)
  return Promise.reject(error);
});

export const Const = Object.freeze({
  API_HOST: process.env.VUE_APP_API_HOST_URL,
  GOOGLE_MAPS_KEY: 'AIzaSyD6ZQ9c4V3Q-nUOGDpFo0pGKgQHNiN9mzk',
  GOOGLE_MAPS_CENTER_LATITUDE: Number(process.env.VUE_APP_MAP_CENTER_LATITUDE),
  GOOGLE_MAPS_CENTER_LONGITUDE: Number(process.env.VUE_APP_MAP_CENTER_LONGITUDE),
  GOOGLE_MAPS_SCALE: Number(process.env.VUE_APP_MAP_SCALE),
  GOOGLE_MAPS_ZOOM: Number(process.env.VUE_APP_MAP_ZOOM),
  HOST: "https://" + window.location.hostname,
  PRIMARY_LOCALE: process.env.VUE_APP_LOCALE,
  PRIMARY_CURRENCY: process.env.VUE_APP_CURRENCY,
  PRIMARY_CURRENCY_SHORT: process.env.VUE_APP_CURRENCY_SHORT,
  SUPPORTED_LOCALES: [
      {locale: "pl", code: "POL", url: "https://mtoilet.pl"},
      {locale: "en", code: "ENG", url: ""},
      {locale: "de", code: "DEN", url: "https://mtoilet.de"},
      {locale: "lt", code: "LTU", url: "https://mtoilet.lt"},
      {locale: "lv", code: "LVA", url: "https://mtoilet.lv"},
      {locale: "ee", code: "EST", url: "https://mtoilet.ee"},
  ],
  CATEGORY_TOILETS: process.env.VUE_APP_CATEGORY_TOILETS,
  CATEGORY_CONTAINERS: process.env.VUE_APP_CATEGORY_CONTAINERS,
  CATEGORY_FANCIES: process.env.VUE_APP_CATEGORY_FANCIES,
  CATEGORY_OTHERS: process.env.VUE_APP_CATEGORY_OTHERS,
  CATEGORY_SERVICE: process.env.VUE_APP_CATEGORY_SERVICE,
  EXCEPTION_WASHBASIN: process.env.VUE_APP_EXCEPTION_WASHBASIN,
  CONTACT_PHONE: process.env.VUE_APP_CONTACT_PHONE,
  CONTACT_EMAIL: process.env.VUE_APP_CONTACT_EMAIL,
})

Vue.mixin({
  data: function () {
    return {
      Const: Const
    }
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
